// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","category":"_1obwl9ZX-DGwwd4jVAQiRP"};